<script lang="ts">
  export let label: string
	export let value: boolean
</script>

<label class="container">
  <div>{label}</div>
  <input 
    type="checkbox" 
    bind:checked={value}
  >
  <span class="checkmark"></span>
</label>

<style lang="scss">
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0em;
    color: #30333D;
    font-weight: normal;
  }

  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 22px;
    width: 22px;
    background-color: white;
    border: 1px solid #B6C8F9;
    border-radius: 4px;
  }

  .container:hover input ~ .checkmark {
    background-color: white;
    border: 1px solid #B6C8F9;
  }

  .container input:checked ~ .checkmark {
    background-color: white;
    border: 1px solid #B6C8F9;
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  .container input:checked ~ .checkmark:after {
    display: block;
  }

  .container .checkmark:after {
    left: 8px;
    top: 2px;
    width: 4px;
    height: 12px;
    border: solid #2B50ED;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>